export const SemicircleIcon = () => {
  const radius = 50;

  return (
    <svg width="40" height="40" viewBox={`0 0 ${radius * 2} ${radius}`}>
      <path
        d={`
          M 0 ${radius}
          A ${radius} ${radius} 0 0 1 ${radius * 2} ${radius}
          L ${radius} ${radius}
          Z
        `}
        fill="#fff"
        stroke="#333"
        strokeWidth="2"
      />
    </svg>
  );
};